webpackJsonp([263791100135453],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(58);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    var siteTitle = this.props.data.site.siteMetadata.title;
	    return Glamor.createElement(
	      'div',
	      { style: { margin: '0 auto', maxWidth: 960, padding: '0px 1.0875rem 1.45rem', paddingTop: 0 } },
	      Glamor.createElement(_reactHelmet2.default, { title: 'About | ' + siteTitle }),
	      Glamor.createElement(
	        'h1',
	        null,
	        'Acerca de ',
	        siteTitle
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'En este blog comparto informaci\xF3n interesante sobre algunos proyectos que he hecho. Los temas principales de este blog son sobre Electr\xF3nica, Control, Programaci\xF3n y Ciberseguridad. Espero que te agrade!'
	      ),
	      Glamor.createElement(
	        'h2',
	        null,
	        'Acerca de m\xED'
	      ),
	      Glamor.createElement(
	        'p',
	        null,
	        'Mi nombre es Maximiliano Valencia y vivo en la ciudad de Celaya, Gto. Estudi\xE9 Ingenier\xEDa Rob\xF3tica en la Universidad Polit\xE9cnica de Guanajuato y Maestr\xEDa en Ciencias con especialidad en Instrumentaci\xF3n y Control en la Universidad Aut\xF3noma de Quer\xE9taro. Actualmente trabajo como Ingeniero de Dise\xF1o Electr\xF3nico en ',
	        Glamor.createElement(
	          'a',
	          { href: 'http://licore.org' },
	          'LICORE'
	        ),
	        ' haciendo sistemas embebidos para aplicaciones de Electr\xF3nica de Potencia y Sistemas de Comunicaciones para Redes El\xE9ctricas Inteligentes.'
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.Component);
	
	exports.default = About;
	var query = exports.query = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-d2f6ffd11f0c4c4990dd.js